import { ReactNode } from 'react';
import {
  BenefitInfoTextExtensionInterface,
  BenefitInfoTextProps,
  BenefitLinkProps,
  BenefitSpecialLinkProps,
} from '../../../../extension/interface/benefit-info-text.extension.interface';

export class MobilityBenefitInfoTextExtension extends BenefitInfoTextExtensionInterface {
  getBenefitLinks(): BenefitLinkProps | undefined {
    return {
      managerSpecific: 'https://www.youtube.com/watch?v=CEGUDMVXgV0',
      appSpecific: 'https://www.youtube.com/watch?v=gb5o-amVugY',
    };
  }

  getBenefitMoreLinks(): BenefitSpecialLinkProps | undefined {
    return undefined;
  }

  getHelpCenterLink(): string | undefined {
    return 'https://support.probonio.de/hc/de/sections/21154631100434--Mobilit%C3%A4tsbudget';
  }

  renderAdditionalContent(_props: BenefitInfoTextProps): ReactNode {
    return null;
  }
}
